/**
 * 是否是pc
 * @param {user agent} ua
 */
export function isPc(ua: string = window.navigator.userAgent) {
    return !/SymbianOS|iphone|android|iPad/i.test(ua);
}